import { render, staticRenderFns } from "./ExplanationParagraph.vue?vue&type=template&id=0d080ffc&scoped=true&"
import script from "./ExplanationParagraph.vue?vue&type=script&lang=ts&"
export * from "./ExplanationParagraph.vue?vue&type=script&lang=ts&"
import style0 from "./ExplanationParagraph.vue?vue&type=style&index=0&id=0d080ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d080ffc",
  null
  
)

export default component.exports